import { UserOverviewDTO } from 'entities/userOverview';
import { DataType } from './UserOverviewWidget.types';

const mapDataToTableColumns = (mappedData: UserOverviewDTO[]): DataType[] => {
  return mappedData?.map(({ id, firstName, lastName, picture, ...user }) => ({
    ...user,
    name: { id, firstName, lastName, picture },
  }));
};

export default mapDataToTableColumns;
